<script>
    import { createEventDispatcher } from 'svelte';

    export let checked = false;

    const dispatch = createEventDispatcher();

    const handleChange = () => dispatch('change', checked);
</script>

<div class="checkbox">
    <label>
        <input
            type="checkbox"
            bind:checked
            on:change={handleChange}
        />
        <slot />
    </label>
</div>

<style>
    .checkbox {
        cursor: pointer;
    }

    .checkbox input {
        margin: 1px 5px 0 0;
        transform: scale(1.1);
    }
</style>
